import { Component } from "react";
import Router from "./routes";
class App extends Component {
  render() {
    return (
      <div className="App">
        <Router />
      </div>
    );
  }
}

export default App;
